function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="15" height="8" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14.207.806L13.514.14a.5.5 0 0 0-.692 0L7.165 5.582 1.515.147a.496.496 0 0 0-.687 0L.141.809a.459.459 0 0 0 0 .661l6.34 6.101a1 1 0 0 0 1.387 0l6.339-6.099a.462.462 0 0 0 0-.666z" fill="#CACACA" /></svg>;
});